import { getOrderFulfillmentCTA } from "./shared";
export var Reimbursement = function Reimbursement(strictLocalize) {
  return {
    titleBuilder: function titleBuilder() {
      return reimbursementOfShippingCostBuilder(strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder() {
      return reimbursementOfShippingCostBuilder(strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getOrderFulfillmentC;
        return (_getOrderFulfillmentC = getOrderFulfillmentCTA(context, strictLocalize)) === null || _getOrderFulfillmentC === void 0 ? void 0 : _getOrderFulfillmentC.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getOrderFulfillmentC2, _getOrderFulfillmentC3;
        return (_getOrderFulfillmentC2 = getOrderFulfillmentCTA(context, strictLocalize)) === null || _getOrderFulfillmentC2 === void 0 ? void 0 : (_getOrderFulfillmentC3 = _getOrderFulfillmentC2.getLink) === null || _getOrderFulfillmentC3 === void 0 ? void 0 : _getOrderFulfillmentC3.call(_getOrderFulfillmentC2);
      }
    }
  };
};
var reimbursementOfShippingCostBuilder = function reimbursementOfShippingCostBuilder(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return strictLocalize({
        id: "n8BFCi",
        defaultMessage: "Reimburse shipping costs when shipping on your own"
      });
    },
    getDescription: function getDescription() {
      return [strictLocalize({
        id: "Rfyot8",
        defaultMessage: "Ship on your own allows you to use your own carrier to ship orders, and we’ll reimburse the shipping cost on your payout up to an approved amount for those orders. You can add or update the shipping cost and tracking number in “Step 4. Shipping info” of the order fulfillment page once it’s available."
      })];
    }
  };
};